import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Sprite } from '../../../odie';
import { ColorId, TvBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/tv'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class TvBlockView extends Container {
  private movieclip: MovieClip;

  constructor(props: TvBlockProps) {
    super();

    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
      y: 4,
    });

    blockPositionView(this, props);
    this.play(props.color);
  }

  public static assets(props: TvBlockProps) {
    return Object.values(manifest());
  }

  public async play(color: ColorId | 'all') {
    await this.movieclip.playAsync('tv_tranisition_1_2');
    if (color === 'all') {
      this.movieclip.play(`tv_state02`, null, true);
    } else {
      this.movieclip.play(`tv_${color}_state01`, null, true);
    }
  }
}
